// Note: Disabling as underscore is added as a dev dep
// in the package.json for the analytics package.
//
// eslint-disable-next-line import/no-extraneous-dependencies
import { noop } from 'underscore';
import { AnalyticsUserData } from '../types';
import BaseTracker from './BaseTracker';

/**
 * Class for connectivity to Braze for user communications (in-app messaging, push notifications).
 */
export class BrazeTracker extends BaseTracker {
  constructor(env: string, platform: string) {
    super('braze', 'Braze', env, platform);
  }

  /**
   * Performs the actual tracking call.
   * NOT IMPLEMENTED FOR BRAZE YET
   *
   * @param {String} eventName The name of the event to track
   * @returns {Promise} Resolves when the event has been logged.
   */

  public trackEvent = noop;

  private isInitialized;

  initializeBraze(userData: AnalyticsUserData) {
    const {
      is_logged_in, user_token,
    } = userData;

    if ('dataLayer' in window && is_logged_in && !this.isInitialized) {
      window.dataLayer.push({ event: 'braze_initialize_sdk', braze_user_id: user_token });
      this.isInitialized = true;
    }
  }

  /**
   * Logs the user's current device with Braze.
   * @global window.AppboyPlugin The Braze SDK. Only loaded in the mobile app.
   * @param userData Data from the analytics package that identifies the current user.
   */
  updateUser(userData: AnalyticsUserData) {
    const {
      hashed_email, is_logged_in, ss_tracking_cookie, user_token,
    } = userData;
    const brazeUserId = is_logged_in ? hashed_email : ss_tracking_cookie;

    this.initializeBraze(userData);

    if ('dataLayer' in window && is_logged_in) {
      window.dataLayer.push({ event: 'braze_update_user', braze_user_id: user_token });
    }

    if (window.AppboyPlugin) {
      window.AppboyPlugin.changeUser(brazeUserId);
    }
  }
}
